import React from 'react';

const Mensaje = ({ total }) => (
    total === 0 ? <p className="">Agrega una cantidad y plazo a pagar para cotizar.</p>
                : <p className="">Debe introducir un monto mayor a RD$ 30,000.</p>
);

export default Mensaje;